<template>
  <div class="flex space-x-3">
    <FreeInput
      v-model="model"
      v-maska:[promoCodeMask]
      :placeholder="$t('promocode.title')"
      :has-error="!!errorMessage"
      :disabled="isLoading"
      size="lg"
      class="flex-1"
      @focus="emit('onFocus')"
    >
      <template #append="{ isClearable, handleClearButtonClick }">
        <button
          v-if="isClearable"
          type="button"
          class="-mx-2 flex items-center justify-center"
          :class="isLoading ? 'text-gray-400' : 'text-static-black'"
          :disabled="isLoading"
          @click="handleClearButtonClick"
        >
          <ClearIcon class="h-6 w-6" />
        </button>
      </template>
      <template #errorMessage>
        <span>{{ errorMessage }}</span>
      </template>
    </FreeInput>
    <button
      type="button"
      :disabled="isLoading"
      class="relative flex h-12 items-center justify-center text-lg font-semibold"
      @click="emit('onSubmit')"
    >
      <LoadingIcon v-if="isLoading" class="absolute h-6 w-6 animate-spin" />
      <span
        class="text-text-neutral-primary"
        :class="isLoading && 'opacity-0'"
        >{{ $t('promocode.apply') }}</span
      >
    </button>
  </div>
</template>

<script setup lang="ts">
  import { FreeInput } from 'freedom-shared';

  import LoadingIcon from '../assets/loading.icon.svg?component';
  import ClearIcon from '../assets/clear.icon.svg?component';

  defineProps<{ errorMessage?: string; isLoading: boolean }>();
  const model = defineModel<string>();
  const emit = defineEmits<{ onSubmit: []; onFocus: [] }>();

  const promoCodeMask = {
    mask: 'F',
    tokens: {
      F: {
        pattern: /./,
        multiple: true,
        transform: (v: string) => v.toLocaleUpperCase(),
      },
    },
  };
</script>
